export default __webpack_public_path__ + "static/demolition-barn-013190e2e82ca36086852201961d9535.png";